<template>
    <slot v-if="content_error === true">
        <div class="header">
            <h2 class="title">
                {{Language.say(title)}}
            </h2>
        </div>

        <main :class='content_class'>
           <ContentEmpty
            :text="content_error_text"
            :icon="content_error_icon"
           />
        </main>
      </slot>

    <slot v-else-if="section_state.loaded[state_id] === true">
        <div class="header">
          <slot name="pre_title"></slot>

          <slot name="title"></slot>

          <h2 v-if="title" class="title">
              {{Language.say(title)}}
          </h2>

          <slot name="pos_title"></slot>

          <div class="actions">
              <slot name="actions"> </slot>
              <slot name="actions_over"> </slot>
          </div>
        </div>

      <slot name="pos_header"></slot>
      <slot name="pre_content">
          <div :class="pre_content_class"> </div>
      </slot>

      <main :class='content_class' v-smart-render-scroll>
          <slot name="content"> </slot>
      </main>
    </slot>

    <slot v-else-if="section_state.loading[state_id]">
      <div class="header">
          <h2 class="title">
              {{Language.say(title)}}
          </h2>
      </div>

      <main :class='content_class'>
          <ContentLoadingFolders/>
      </main>
    </slot>
</template>

<script setup>
  import { defineProps }        from "vue";
  import ContentLoadingFolders  from '@/vue/Elements/Content/ContentLoadingFolders.vue';
  import ContentEmpty           from "@/vue/Elements/Content/ContentEmpty.vue";
  import Language               from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    title : {
      default : ''
    },

    loading_list : {
      default: 'folders'
    },

    section_state : {
      required: true,
    },

    state_id : {
      required: true,
    },

    content_error : {
      default : false,
    },

    content_error_text : {
      default : 'global.content.empty'
    },

    content_error_icon : {
      default : ''
    },

    content_class : {
      default: 'content',
    },

    pre_content_class : {
      default: '',
    }
  })

  // const onErrorRetry = () => {
  //   props.content_state.errorRetry();
  // }
</script>